<template>
  <div class="addvip">
   <div class="content">
      <!-- 标题 -->
    <div class="title">
      <i class="el-icon-edit"></i>
      <span>新增证书信息</span>

      <!-- 返回按钮 -->
      <div class="back">
        <el-button round size='mini' class="back-btn" icon='el-icon-arrow-left' @click="back">返回</el-button>
      </div>
    </div>
    

    <!-- 表单内容 -->
    <el-form :model="form" class="main" size="medium" status-icon label-width="120px" ref="ruleForm">

     
      <el-form-item label="身份证号:" prop="idNum" :rules="[{ required: true, message: '身份证不能为空', trigger: ['blur','change']}]">
        <el-input v-model="form.idNum" placeholder="请输入身份证号" ></el-input>
      </el-form-item>
      <el-form-item label="证书编号:" prop="num" :rules="{ required: true, message: '证书编号不能为空', trigger: ['blur','change']}" >
        <el-input v-model="form.num" placeholder="请输入证书编号"></el-input>
      </el-form-item>
       <el-form-item label="广西跆协编号:" prop="xnum" :rules="{ required: true, message: '证书编号不能为空', trigger: ['blur','change']}" >
        <el-input v-model="form.xnum" placeholder="请输入证书编号"></el-input>
      </el-form-item>
      <el-form-item label="证书名称:" prop="name" :rules="{ required: true, message: '证书名称不能为空', trigger: ['blur','change']}" >
        <el-input v-model="form.name" placeholder="请输入证书名称"></el-input>
      </el-form-item>

      <el-form-item label="证书等级:" prop="level"
      :rules="{ required: true, message: '证书等级不能为空', trigger: ['blur','change']}">
        <el-input v-model="form.level" placeholder="请输入证书等级" ></el-input>
      </el-form-item>

      <el-form-item label="发证日期:" prop="startTime" >
        <!-- <el-input v-model="form.info" placeholder="请输入发证日期" ></el-input> -->
        <el-date-picker type="date" value-format="yyyy-MM-dd" class="time-input" placeholder="选择发证日期" v-model="form.startTime"></el-date-picker>
      </el-form-item>
       <el-form-item label="终止日期:" prop="endTime" >
        <!-- <el-input v-model="form.info" placeholder="请输入终止日期" ></el-input> -->
        <el-date-picker type="date" value-format="yyyy-MM-dd" class="time-input" placeholder="选择终止日期" v-model="form.endTime"></el-date-picker>
      </el-form-item>
       
      <el-form-item class="control">
        <el-button type="danger" icon="el-icon-close" @click="back">取消</el-button>
        <el-button @click="resetForm('ruleForm')" class="reset-btn" icon="el-icon-refresh-left">重置</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')" icon="el-icon-document-add">保存</el-button>
      </el-form-item>

      
    </el-form>
   </div>
  </div>
</template>
<script>
 export default {
    data() {
   
      return {
        form: {
          //img:'',
          idNum:'',
          num:'',
          name:'',
          level:'',
          startTime:"",
          endTime:'',
          status:'有效'
          
        },
       
      }
    },
    methods: {
      back(){//返回房产信息列表
        this.$router.push({path:'/home/course'});
      },




      // 提交表单
      submitForm(formName) {
       
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log("seccess!",this.form);
            this.axios.post('/teacher/findCert',{
              num:this.form.num
              
            })
            .then(res=> {
              console.log(res.data);
              if(res.data.code == 0){
                this.$message.error(res.data.msg);
              }
              else{
                 if(res.data.data){
                 this.$message.info("证书已经存在！"); 
                 }else{
                this.form.operater=sessionStorage.getItem("tel");
                this.axios.post("/teacher/addCert",{
                  //img:this.form.img,
                  idNum:this.form.idNum,
                  num:this.form.num,
                  xnum:this.form.xnum,
                  name:this.form.name,
                  level:this.form.level,
                  startTime:this.form.startTime,
                  endTime:this.form.endTime,
                  operater:this.form.operater,
                  status:this.form.status
                })
                .then(res=>{
                  console.log(res);
                  if(res.data.code=='200'){
                    this.$message.success(res.data.msg);
                    this.$router.push({path:'/home/course'});
                  }
                })
                .catch(err=>{
                  this.$message.error(err);
                })
              }
              }
            })
            .catch(err=>{
              console.log(err);
            })

          } else {
            console.log('error submit!!');
            return false;
          }
        });
        
      },
      // 重置表单
      resetForm(formName) {
        this.$refs[formName].resetFields();
      },

    }
  }
</script>
<style lang="less">
@import "../assets/less/base.less";

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: @greenColor;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

<style lang="less" scoped>
@import "../assets/less/base.less";
.addvip {
  color: @fontColor;
  background-color: white;
  min-height: 500px;
}
.content {
  background: white;
}
.title {
  padding: 15px 20px;
  border-top: 3px solid #e7eaec;
  border-bottom: 1px solid #e7eaec;
  i {
    margin-right: 2px;
  }
  .back {
    float: right;
    .back-btn{
      padding: 5px;
    }
  }
}
.main{
  padding: 20px;
}
.el-input--medium,.el-select,.time-input{
  width: 300px;
}
.reset-btn{
  background: @blueGreenColor;
  color: white;
  border-color: @blueGreenColor;
}
.el-form--inline .control{
  text-align: right;
  width: 100%;
}
</style>